<template>
    <!-- <footer class="pl-14"></footer> -->
    <p class="text-sm text-neutral-500 pt-24 text-center">© 2025 Reddensoft Infotech. All rights reserved. Designed and developed by Reddensoft Infotech.</p>
</template>
<script>
    //import { BASE_URL } from "../../config";
    //import axios from "axios";
    //import { createLocal } from 'the-storages';

    //const mirror = createLocal();
    //const storage = mirror._prx;

    export default {
        name: 'FooterSection',
        data() {
            return {
               //ipAddress:'',
            }
        },
        created(){
        }
    }
</script>